import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";


export default (theme: APTheme) => createStyles({
    root: {
        display: "block",
        height: 212,
    },
    loadingCircle: {
        position: "absolute",
        zIndex: 1
    },
    progressTimeNumber: {
        fontSize: 45,
        fontWeight: "bold",
        top: -160,
        position: "relative"
    },
    progressTimeInWord: {
        fontSize: 21,
        top: -164,
        position: "relative"
    }
});